import React from 'react';
import colors from 'constants/colors';

const FolderFilled = ({ color = '$fmDisabledIcons' }) => (
    <svg viewBox={'0 0 18 18'} xmlns="http://www.w3.org/2000/svg">
        <path
            d="M16.123 2.853h-7.05L8.05 1H1.87C.84 1 0 1.822 0 2.832V15.23c0 .999.83 1.811 1.85 1.811h14.272c1.036 0 1.878-.825 1.878-1.84V4.693c0-1.014-.842-1.84-1.877-1.84"
            fill={colors[color] ? colors[color] : '#CED4D9'}
            fillRule="evenodd"
        />
    </svg>
);

export default FolderFilled;
